import React, {Component} from 'react';
import {Link, Redirect, withRouter} from 'react-router-dom';
import $ from "jquery";
import fetch from "isomorphic-fetch";
import db from "../dbconn";
import {API_ROOT} from "../api-config";
import Modal from 'react-responsive-modal';
import moment from 'moment-timezone';
import Swal from "sweetalert2";
import {withTranslation} from 'react-i18next';
import i18n from '../i18n';


class order_history extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            nosessionredirect: false,
            open: false,
            orderList: [],
            windowHeight: 0,
            categoryList: [],
            swalButton: ''
        };
    };

    onOpenModal = () => {
        this.setState({open: true});

    };
    onCloseModal = () => {
        this.setState({open: false});
    };

    componentWillMount() {

        if(!localStorage.getItem("store_language")){
            localStorage.setItem("store_language","en")
        }
        i18n.changeLanguage(localStorage.getItem("store_language")).then(r => {
        });
        this.setState({
            swalButton: Swal.mixin({
                customClass: {
                    confirmButton: 'link_button',
                    cancelButton: 'link_button'
                },
                buttonsStyling: false,
            })
        });
        var dbconn = new db();

        dbconn.getAll().then(data => {

            if (!data || data.length < 1 || sessionStorage.getItem('guestFlag') == 'Y') {
                this.setState({nosessionredirect: true});
            } else {

                var customer_id = data[0].customer_id;
                var customer_token = data[0].customer_token;
                var url = API_ROOT + '/fetchorderhistory?customer_id=' + customer_id + '&store_id=' + localStorage.getItem('store_id') + '&customer_token=' + customer_token + '&timezone=' + moment.tz.guess();

                this.searchOrder(url);


            }
        });
    }

    searchOrder = (url) => {
        this.onOpenModal();

        fetch(url)
            .then(response => {
                return response.json();
            })
            .then(orderData => {

                this.onCloseModal();
                if (orderData.status == 1) {

                    this.setState({orderList: orderData.order_data});
                } else {

                    this.state.swalButton.fire({title: orderData.message, allowOutsideClick: false});
                }
            });
    }

    componentDidMount() {

        document.title = "Order History - " + localStorage.getItem("store_name") + " - Tria Commerce";

        var primaryColor = localStorage.getItem("store_primary_color");

        if (primaryColor != null) {
            document.documentElement.style.setProperty('--primaryColor', primaryColor);
        }
        var secondaryColor = localStorage.getItem("store_secondary_color");


        if (secondaryColor != null) {
            document.documentElement.style.setProperty('--secondaryColor', secondaryColor);
        }
        var lightColor = localStorage.getItem("store_light_color");

        if (lightColor != null) {
            document.documentElement.style.setProperty('--lightColor', lightColor);
        }
        var buttonColor = localStorage.getItem("store_button_color");

        if (buttonColor != null) {
            document.documentElement.style.setProperty('--buttonColor', buttonColor);
        }

        $('#searchStringTxt').keyup(e => {

            if (e.which == 13) {

                var dbconn = new db();

                dbconn.getAll().then(data => {

                    if (!data || data.length < 1 || sessionStorage.getItem('guestFlag') == 'Y') {
                        this.setState({nosessionredirect: true});
                    } else {

                        var customer_id = data[0].customer_id;
                        var customer_token = data[0].customer_token;

                        var url = "";
                        if ($('#searchStringTxt').val() == "") {
                            url = API_ROOT + '/fetchorderhistory?customer_id=' + customer_id + '&store_id=' + localStorage.getItem('store_id') + '&customer_token=' + customer_token + '&timezone=' + moment.tz.guess();
                        } else {
                            url = API_ROOT + '/fetchorderhistory?customer_id=' + customer_id + '&store_id=' + localStorage.getItem('store_id') + '&search=' + $('#searchStringTxt').val() + '&customer_token=' + customer_token + '&timezone=' + moment.tz.guess();
                        }


                        this.searchOrder(url);

                    }
                });
            } else {


                var dbconn = new db();

                dbconn.getAll().then(data => {

                    if (!data || data.length < 1 || sessionStorage.getItem('guestFlag') == 'Y') {
                        this.setState({nosessionredirect: true});
                    } else {

                        var customer_id = data[0].customer_id;
                        var customer_token = data[0].customer_token;

                        var url = "";
                        if ($('#searchStringTxt').val() == "") {
                            url = API_ROOT + '/fetchorderhistory?customer_id=' + customer_id + '&store_id=' + localStorage.getItem('store_id') + '&customer_token=' + customer_token + '&timezone=' + moment.tz.guess();
                            this.searchOrder(url);
                        }


                    }
                });
            }
        });


        var height = $(window).height();
        this.setState({windowHeight: height});
    }

    render() {
        const {t} = this.props;
        const {open} = this.state;

        if (this.state.nosessionredirect) {
            return (<Redirect to={'/'}/>);
        }

        return (
            <div className="mainContainer">
                <header>
                    <div className="col-md-12 col-sm-12 col-xs-12 previous-link">

                        <Link to={'/myaccount'}></Link>

                        <h2 className="text-center m-2-0"><strong>{t('order_history')}</strong></h2>
                    </div>
                </header>
                <div className="mt-white full-height" style={{top: "45px", position: "relative"}}>
                    <div className="simple-box m-b-0 p-b-35  bkg-white full-height m-grey"
                         style={{overflowY: "scroll"}}>


                        <div className="form-box w-75 div-center">


                            <div className="header-title">
                                <h2 className="text-center font-size-20 m-0">{t('previous_orders')}</h2>
                            </div>
                            <div className="header-content order_content">
                                <input type="text" className="search_text" name="searchStringTxt" id="searchStringTxt"
                                       placeholder={t('search_order')}/>

                                <ul>
                                    {this.state.orderList.map((item, index) => {

                                        return (<li><p key={item.order_id} className="font-family-bold" style={{
                                            marginBottom: "0px",
                                            width: "95%",
                                            textAlign: "left",
                                            paddingLeft: "10px",
                                            paddingRight: "10px",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis"
                                        }}><Link style={{textDecoration: 'none', color: "black"}}
                                                 to={'/order/summary/' + item.order_id}><u
                                            style={{color: "var(--primaryColor)"}}>#{item.order_check_number}</u> - {item.order_created_at} -
                                            ${item.order_total.toFixed(2)} - {item.order_summary}</Link></p></li>);
                                    })

                                    }
                                </ul>
                            </div>

                        </div>
                        <div className="clearfix"></div>
                        <div className="form-group w-60-d m-t-0 w-60-d1" style={{marginBottom: "30px"}}>
                            <Link to={'/menu'} className="link_button">{t('start_new_order')}</Link>
                        </div>

                    </div>
                </div>
                <Modal closeOnEsc={false} closeOnOverlayClick={false} showCloseIcon={false} open={open}
                       onClose={this.onCloseModal} center>
                    <h2>&nbsp;&nbsp;&nbsp;&nbsp;{t('loading')}...&nbsp;&nbsp;&nbsp;&nbsp;</h2>

                    <p style={{textAlign: 'center'}}>
                        <img width={'40'} height={'40'} src={'/img/loader.gif'}/>
                    </p>
                </Modal>
            </div>
        );
    }
}

export default withRouter(withTranslation()(order_history));


// WEBPACK FOOTER //
// ./src/view_components/order_history.js